module.exports = __webpack_public_path__ + "static/img/icon_suc.fdc2f655.jpg";